import React from 'react'
import { Fade } from 'react-awesome-reveal'
import { blog } from '../utility/blog'
import { blogitem } from '../utility/blogitem'
import { NavLink } from 'react-router-dom'


function Blog() {

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  return (
    <>
      <section className="section-breadcrumb">
        <div className="top_outline_01"></div>
        <div className="top_outline_02"></div>
        <div className="bottom_outline_01"></div>
        <div className="bottom_outline_02"></div>
        <div className="container-fulid">
          <div className="row">
            <div className="col-12">
              <div className="zx-breadcrumb padding-tb-100">
                <div className="banner mb-15 justify-content-center">
                  <h2>Blog</h2>
                </div>
                <div className="entry-breadcrumb">
                  <h5>
                    <span>
                      <NavLink to="/">Home</NavLink>
                    </span>
                    <span> / </span>
                    <span className="post-page">
                      <NavLink to="/blog">Blog</NavLink>
                    </span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-Blog padding-tb-100">
        <div className="container">
          <div className="row">
            <Fade triggerOnce duration={1000} direction='up' className="col-lg-4 col-12" >
              <>
                <div className="zx-blog-serch-box">
                  <form className="form-inline my-lg-0 d-flex">
                    <input className="form-conrol" type="search" placeholder="Search here" aria-label="Search" />
                    <button onClick={handleSubmit} className="blog-serch-button">
                      <i className="fa fa-search" aria-hidden="true"></i>
                    </button>
                  </form>
                </div>
                <div className="zx-block-inner">
                  {
                    blog.map((data, index) => (
                      <div key={index} className="zx-block">
                        <a onClick={handleSubmit} href="/">{data.title}</a>
                        <h5>{data.date} - {data.comment}</h5>
                      </div>
                    ))
                  }

                </div>
                <div className="zx-caegories">
                  <h3>Categories</h3>
                  <input type="checkbox" id="checkbox1" name="checkbox-1" value="Digital" />
                  <label htmlFor="checkbox1">Machine Learning (ML)</label>
                  <input type="checkbox" id="checkbox2" name="checkbox-2" value="Marketing" />
                  <label htmlFor="checkbox2">Natural Language Processing (NLP)</label>
                  <input type="checkbox" id="checkbox3" name="checkbox-3" value="eCommerce" />
                  <label htmlFor="checkbox3">AI Ethics and Bias</label>
                  <input type="checkbox" id="checkbox4" name="checkbox-4" value="Sales" />
                  <label htmlFor="checkbox4">AI in Healthcare</label>
                  <input type="checkbox" id="checkbox5" name="checkbox-5" value="Lifestyle" />
                  <label htmlFor="checkbox5">AI in Business</label>
                  <input type="checkbox" id="checkbox6" name="checkbox-6" value="Technology" />
                  <label htmlFor="checkbox6">Robotics and Automation</label>
                </div>
              </>
            </Fade>
            <Fade triggerOnce direction='up' duration={1500} className="col-lg-8 col-12" >
              <div className="row mb-m-30">
                <>
                  {
                    blogitem.map((data, index) => (
                      <div key={index} className="col-lg-6 col-md-6 col-12">
                        <div className="zx-blog-inner">
                          <div className="zx-image">
                            <img src={data.image} alt="1" className="w-100" />
                          </div>
                          <div className="digital-blog">
                            <h4><code>{data.title} </code> - {data.date} - {data.comment}</h4>
                            <p>
                              {data.discription}
                            </p>
                            <a onClick={handleSubmit} href="/">
                              <h5>Read more <i className="fa-solid fa-arrow-right-long"></i></h5>
                            </a>
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </>
              </div>
            </Fade>
          </div>
        </div>
      </section>


    </>
  )
}

export default Blog
